import { render } from "./eyerweb-menu.vue?vue&type=template&id=37aa6390&scoped=true"
import script from "./eyerweb-menu.vue?vue&type=script&lang=js"
export * from "./eyerweb-menu.vue?vue&type=script&lang=js"

import "./eyerweb-menu.vue?vue&type=style&index=0&id=37aa6390&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37aa6390"]])

export default __exports__